import moment from "moment";

export default function VoucherList(props) {
    
    // === Checks List - Determine which message to display if looking at whole voucher list ===
    let showLockedMsg = "false";
    let lockedMsgFlag;
    (props.vouchers).forEach((voucher) => {
        if (voucher.isLocked) {
            showLockedMsg = "true";
            if (props.voucherIssueIdInCart == voucher.loyaltyIssuedProductID) {
                lockedMsgFlag = "1"; // Locked Message to display for 'In Cart'
            } else {
                lockedMsgFlag = "2"; // Locked Message to display for 'Used In Another Cart'
            }
        }
    })

    let voucherList = props.vouchers.length > 0 ? 
        props.vouchers.map((item) => {
            let expiryDate = item.loyaltyProductExpiryDate ? moment(item.loyaltyProductExpiryDate, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY') : '';
            let lockedBadge;
            let lockedFlag = ""; // Determines which message to display to the user if unable to redeem voucher
            if (item.isLocked && item.productType === 'item' && item.discountTypeString === 'DollarFixed') {
                showLockedMsg = "true"; // Checks List
                if (props.voucherIssueIdInCart == item.loyaltyIssuedProductID) {
                    lockedBadge = <span className="badge bg-dark fw-medium">In Cart</span>
                    lockedFlag = "1"; // Voucher Exists in Current In Cart
                    lockedMsgFlag = "1"; // Locked Message to display for 'In Cart' - Checks List
                } else {
                    lockedBadge = <span className="badge bg-dark fw-medium">Used In Another Cart</span>
                    lockedFlag = "2"; // Voucher Used In Another Cart
                    lockedMsgFlag = "2"; // Locked Message to display for 'Used In Another Cart' - Checks List
                }
            } else {
                lockedBadge = <></>
                lockedFlag = "0"; // Not Locked & Valid > Able to redeem
            }

            let redeemInStoreBadge;
            if (item.productType === 'item' && item.discountTypeString === 'DollarFixed') {
                // Currently only able to redeem:
                // - Dollar Fixed Total Vouchers 
                redeemInStoreBadge = <></>
            } else {
                redeemInStoreBadge = <span className="badge bg-secondary-subtle text-dark-emphasis fw-normal">Redeem In-Store</span>
            }

            return (
                <div className="mt-3" key={item.loyaltyIssuedProductID}>
                    <button type="button" className="btn btn-light border w-100 text-start pb-2" onClick={props.handleSelectVoucher} producttype={item.productType} discounttype={item.discountTypeString} issuedvoucherid={item.loyaltyIssuedProductID} memberid={item.memberID} lockedflag={lockedFlag} showlockedmsg={showLockedMsg} lockedmsgflag={lockedMsgFlag} >
                        <div className="d-flex flex-column gap-1">
                            <span className="fw-medium">{item.loyaltyProductNameExternal}</span>
                            <span className="text-muted mb-2">{item.loyaltyProductRewardDescription}</span>
                            <div className="d-flex flex-row justify-content-between">
                                <div className="d-flex flex-sm-row flex-column gap-2">
                                    <span className="badge bg-secondary-subtle text-dark-emphasis fw-normal">Expiry {expiryDate}</span>
                                    {redeemInStoreBadge}
                                </div>
                                {lockedBadge}
                            </div>
                        </div>
                    </button>
                </div>
            )
        })
        :
        <div className="text-center py-5 border rounded mt-3 mb-1">No vouchers are currently available.</div>

    return voucherList
}